module.exports = __webpack_public_path__ + "img/play-on.fa3c5af4.png";